import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import * as AWS from 'aws-sdk';
import {Observable, Observer} from 'rxjs';
import {concatMap} from 'rxjs/operators';

@HookClass('aws.rekognition')
export class AwsRekognitionHook extends BaseHook {

    @Hook('6433d7a3-8c80-4563-bb03-fe804df22b78')
    public rekognition(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings: any) => {

                const rkn = new AWS.Rekognition({
                    params: {Bucket: settings.aws.bucketName},
                    region: 'us-east-1',
                    credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
                });

                return new Observable((observer: Observer<any>) => {

                    let bucketName;

                    if (inputArtifact.object.config && inputArtifact.object.config.bucket)
                        bucketName = inputArtifact.object.config.bucket;

                    const params = {
                        SourceImage: {
                            S3Object: {
                                Bucket: `${bucketName ? bucketName : settings.aws.bucketName}`,
                                Name: inputArtifact.object.data.source.key
                            }
                        },
                        TargetImage: {
                            S3Object: {
                                Bucket: `${bucketName ? bucketName : settings.aws.bucketName}`,
                                Name: inputArtifact.object.data.target.key
                            }
                        },
                        SimilarityThreshold: 70
                    };

                    rkn.compareFaces(params, (err: any, response: any) => {
                        if (err) {
                            observer.error(err);
                        } else {
                            const outputArtifact = new NickProcessArtfact();
                            outputArtifact.kind = ArtfactKind.ANY;
                            outputArtifact.object = response;
                            observer.next(outputArtifact);
                        }

                        observer.complete();
                    });
                });
            }));
    }

}
